// extracted by mini-css-extract-plugin
module.exports = {"headerWrapper":"header-module--headerWrapper--3fja5","title":"header-module--title--2wclG","subtitle":"header-module--subtitle--3zh3B"};